'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobAlphanumericInput', cobAlphanumericInput);

	function cobAlphanumericInput() {

		return {
			require: 'ngModel',
			link: function($scope, $element) {

				$element.bind('keydown',
					function(event) {
						var charCode = (event.which) ? event.which : event.keyCode;
						var key = event.keyCode;
						var isShift = !!event.shiftKey;

						switch (charCode) {
						case 8: //backspace
						case 35: //end
						case 36: //home
						case 37: //left arrow
						case 39: //right arrow
						case 46: //delete
							return;
						}

						// If the keys include the TAB, CTRL, SHIFT, ALT, or META keys, 10 key pad, or the arrow keys, do nothing.
						// This lets us support copy and paste too
						if ((key === 91) ||
                        (15 < key && key < 19) ||
                        (37 <= key && key <= 40) ||
                        (key === 9) ||
                        (96 <= key && key <= 105)) {
							return;
						}

						if (!/^[a-z0-9]+$/i.test(String.fromCharCode(charCode))) {
							event.preventDefault();
						}

						if (isShift) {
							if (charCode >= 48 && charCode <= 57) {
								event.preventDefault();
							}
						}
					});
			}
		};
	}
})();
